/* istanbul ignore file */
import useInvoiceService, { RUN_INVOICE_SUBTOTAL_UPDATE } from 'domain/finance/invoice/useInvoiceService';
import RunMigrationButton from 'domain/finance/shared/button/RunMigrationButton';

const LOCAL_STORAGE_KEY = 'invoice-migration-data';

const RunInvoiceMigrationButton = () => {
  const { runUpdateInvoiceSubTotals } = useInvoiceService();

  return (
    <RunMigrationButton
      displayMessage="Are you sure you want to update invoice sub totals? This action cannot be undone. Please, Fill out inputs below"
      localStorageKey={LOCAL_STORAGE_KEY}
      submitMethod={runUpdateInvoiceSubTotals}
      permissionToCheck={RUN_INVOICE_SUBTOTAL_UPDATE}
    >
      Update sub totals
    </RunMigrationButton>
  );
};

export default RunInvoiceMigrationButton;
